export var SEND_PUSH_TOKEN = 'SEND_PUSH_TOKEN';
export var SUCCESS_PUSH_TOKEN = 'SUCCESS_PUSH_TOKEN';
export var FAILURE_PUSH_TOKEN = 'FAILURE_PUSH_TOKEN';
export var SET_PUSH_STATE = 'SET_PUSH_STATE';
export var REQUEST_PUSH_STATE = 'REQUEST_PUSH_STATE';